// 关键字优先级排序，数字越小优先级越高
const keywordPriority = {
	'会长': 1,
	'副会长': 2,
	'秘书长': 3,
	'副秘书长': 4,
	'理事长': 5,
	'副理事长': 6,
	'常务理事': 7,
	'理事': 8,
	'监事长': 9,
	'监事': 10,
	'会员': 11,
};

// 获取职务的排序权重
const getPostPriority = (post) => {
	if (!post || post.trim() === '') {
		return {firstLevel: 999, secondLevel: 999, complexity: 0}; // 空职务排在最后
	}

	let matchedKeywords = [];

	// 按关键字长度降序排列，优先匹配更长的关键字
	const sortedKeywords = Object.keys(keywordPriority).sort((a, b) => b.length - a.length);

	// 找到所有匹配的关键字，避免重复匹配
	let remainingPost = post;
	for (const keyword of sortedKeywords) {
		if (remainingPost.includes(keyword)) {
			matchedKeywords.push({keyword, priority: keywordPriority[keyword]});
			// 移除已匹配的关键字，避免"副会长"同时匹配"副会长"和"会长"
			remainingPost = remainingPost.replace(keyword, '');
		}
	}

	// 按优先级排序（数字越小优先级越高）
	matchedKeywords.sort((a, b) => a.priority - b.priority);

	// 第一层：最高优先级
	const firstLevel = matchedKeywords.length > 0 ? matchedKeywords[0].priority : 999;

	// 第二层：次高优先级，如果只有一个关键字则为999
	const secondLevel = matchedKeywords.length > 1 ? matchedKeywords[1].priority : 999;

	// 复杂度：职务长度，用于同级别内的细分排序
	const complexity = post.length;

	return {firstLevel: firstLevel, secondLevel: secondLevel, complexity: complexity};
};

export const SortByMemberUnitPost = (originalList) => {
	return originalList.sort((a, b) => {
		const postA = a.memberUnitPost?.trim() || '';
		const postB = b.memberUnitPost?.trim() || '';
		const weightA = getPostPriority(postA);
		const weightB = getPostPriority(postB);

		// 三层排序：第一层优先级 → 第二层优先级 → 复杂度
		if (weightA.firstLevel !== weightB.firstLevel) {
			return weightA.firstLevel - weightB.firstLevel;
		}
		if (weightA.secondLevel !== weightB.secondLevel) {
			return weightA.secondLevel - weightB.secondLevel;
		}
		return weightA.complexity - weightB.complexity;
	});
};

export const SortByMemberPost = (originalList) => {
	return originalList.sort((a, b) => {
		const postA = a.memberPost?.trim() || '';
		const postB = b.memberPost?.trim() || '';
		const weightA = getPostPriority(postA);
		const weightB = getPostPriority(postB);

		// 三层排序：第一层优先级 → 第二层优先级 → 复杂度
		if (weightA.firstLevel !== weightB.firstLevel) {
			return weightA.firstLevel - weightB.firstLevel;
		}
		if (weightA.secondLevel !== weightB.secondLevel) {
			return weightA.secondLevel - weightB.secondLevel;
		}
		return weightA.complexity - weightB.complexity;
	});
};

export const SortByOrganizationPost = (originalList) => {
	return originalList.sort((a, b) => {
		const postA = a.organizationPost?.trim() || a.organization_post?.trim() || '';
		const postB = b.organizationPost?.trim() || b.organization_post?.trim() || '';
		const weightA = getPostPriority(postA);
		const weightB = getPostPriority(postB);

		// 三层排序：第一层优先级 → 第二层优先级 → 复杂度
		if (weightA.firstLevel !== weightB.firstLevel) {
			return weightA.firstLevel - weightB.firstLevel;
		}
		if (weightA.secondLevel !== weightB.secondLevel) {
			return weightA.secondLevel - weightB.secondLevel;
		}
		return weightA.complexity - weightB.complexity;
	});
};

export const SortByMbskPost = (originalList) => {
	return originalList.sort((a, b) => {
		const postA = a.mbskPost?.trim() || '';
		const postB = b.mbskPost?.trim() || '';
		const weightA = getPostPriority(postA);
		const weightB = getPostPriority(postB);

		// 三层排序：第一层优先级 → 第二层优先级 → 复杂度
		if (weightA.firstLevel !== weightB.firstLevel) {
			return weightA.firstLevel - weightB.firstLevel;
		}
		if (weightA.secondLevel !== weightB.secondLevel) {
			return weightA.secondLevel - weightB.secondLevel;
		}
		return weightA.complexity - weightB.complexity;
	});
};

export const SortByZhiWu = (originalList) => {
	// 党务职务关键字优先级
	const partyKeywordPriority = {
		'书记': 1,
		'副书记': 2,
		'纪检委员': 3,
		'组织委员': 4,
		'宣传委员': 5,
		'其他': 6,
	};

	// 获取党务职务的排序权重
	const getPartyPostPriority = (post) => {
		if (!post || post.trim() === '') {
			return {firstLevel: 999, secondLevel: 999, complexity: 0};
		}

		let matchedKeywords = [];

		// 按关键字长度降序排列，优先匹配更长的关键字
		const sortedKeywords = Object.keys(partyKeywordPriority).sort((a, b) => b.length - a.length);

		// 找到所有匹配的关键字，避免重复匹配
		let remainingPost = post;
		for (const keyword of sortedKeywords) {
			if (remainingPost.includes(keyword)) {
				matchedKeywords.push({keyword, priority: partyKeywordPriority[keyword]});
				// 移除已匹配的关键字，避免重复匹配
				remainingPost = remainingPost.replace(keyword, '');
			}
		}

		// 按优先级排序（数字越小优先级越高）
		matchedKeywords.sort((a, b) => a.priority - b.priority);

		// 第一层：最高优先级
		const firstLevel = matchedKeywords.length > 0 ? matchedKeywords[0].priority : 999;

		// 第二层：次高优先级，如果只有一个关键字则为999
		const secondLevel = matchedKeywords.length > 1 ? matchedKeywords[1].priority : 999;

		// 复杂度：职务长度，用于同级别内的细分排序
		const complexity = post.length;

		return {firstLevel: firstLevel, secondLevel: secondLevel, complexity: complexity};
	};

	return originalList.sort((a, b) => {
		const postA = a.party_post?.trim() || a.partyPost?.trim() || '';
		const postB = b.party_post?.trim() || b.partyPost?.trim() || '';
		const weightA = getPartyPostPriority(postA);
		const weightB = getPartyPostPriority(postB);

		// 三层排序：第一层优先级 → 第二层优先级 → 复杂度
		if (weightA.firstLevel !== weightB.firstLevel) {
			return weightA.firstLevel - weightB.firstLevel;
		}
		if (weightA.secondLevel !== weightB.secondLevel) {
			return weightA.secondLevel - weightB.secondLevel;
		}
		return weightA.complexity - weightB.complexity;
	});
};